import Icon from "./logo";
var CnLayoutContentPrototype = {
  title: '页面内容',
  componentName: 'CnLayoutContent',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  canOperating: false,
  configure: [{
    name: 'isCnLayoutContent',
    title: 'CnLayoutContent',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutContentPrototype };